@let profile = profile$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="{{defaultBackHref}}/profile/{{profileId}}"></ion-back-button>
    </ion-buttons>
    <ion-title>Details & Characteristics</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <ion-accordion-group expand="inset" [multiple]="false" [value]="'details'">
    <ion-accordion value="details">
      <ion-item slot="header" color="light">
        <ion-label>Property Details</ion-label>
      </ion-item>
      <ion-list slot="content" lines="full">
        <ion-item>
          <ion-label color="medium">
            Address<br />
            <ion-note color="dark" class="tw:font-bold tw:text-wrap">
              {{profile?.SiteAddress | redDashIfEmpty}}
            </ion-note>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">City</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.SiteCity | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">State</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.SiteState | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">ZIP</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.SiteZip | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">
            Parcel Number<br />
            <ion-note color="dark" class="tw:font-bold tw:text-wrap"> {{profile?.APN | redDashIfEmpty}} </ion-note>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Unit</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.SiteUnit | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Unit Type</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.SiteUnitType | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">City Muni. TWP</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.CityMuniTwp | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Assessed Value</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.AssessedValue | redCurrency}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Tax Amount</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.TaxAmount | redCurrency}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">
            Legal Brief<br />
            <ion-note color="dark" class="tw:font-bold tw:text-wrap">
              {{profile?.LegalBriefDescription | redDashIfEmpty}}
            </ion-note>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-accordion>
    <ion-accordion value="owner">
      <ion-item slot="header" color="light">
        <ion-label>Owner Information</ion-label>
      </ion-item>
      <ion-list slot="content" lines="full">
        <ion-item>
          <ion-label color="medium">
            Owner Name<br />
            <ion-note color="dark" class="tw:font-bold tw:text-wrap">
              {{[profile?.PrimaryOwnerName, profile?.SecondaryOwnerName].join('\n') | redDashIfEmpty}}
            </ion-note>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label color="medium">
            Mailing Address<br />
            <ion-note color="dark" class="tw:font-bold tw:text-wrap">
              {{[[profile?.mailingAddress, profile?.mailingCity].join(' '), [(profile$ | async)?.mailingState,
              [profile?.mailingZip, profile?.mailingZip4].join('-') ].join('&nbsp;')].join(', ') | redDashIfEmpty}}
            </ion-note>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-accordion>
    <ion-accordion value="characteristics">
      <ion-item slot="header" color="light">
        <ion-label>Property Characteristics</ion-label>
      </ion-item>
      <ion-list slot="content" lines="full">
        <ion-item>
          <ion-label color="medium">Year Built</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.YearBuilt | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Building Area</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.BuildingArea | redSurface}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Lot Size</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end">
            {{profile?.LotSize | redSurface:profile?.LotSizeUnits}}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Bedrooms</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.Bedrooms | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Bathrooms</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.Baths | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Garage Type</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.GarageType | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Garage Num. Cars</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end">
            {{profile?.GarageNumCars | redDashIfEmpty}}
          </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Total Rooms</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.TotalRooms | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Fireplace</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.Fireplace | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Number of Units</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.NumUnits | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Zoning</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.Zoning | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">Pool</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.Pool | redDashIfEmpty}} </ion-note>
        </ion-item>
        <ion-item>
          <ion-label color="medium">
            Use Code<br />
            <ion-note color="dark" class="tw:font-bold tw:text-wrap"> {{profile?.UseCode | redDashIfEmpty}} </ion-note>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label color="medium">Basement</ion-label>
          <ion-note class="tw:font-bold" color="dark" slot="end"> {{profile?.Basement | redDashIfEmpty}} </ion-note>
        </ion-item>
      </ion-list>
    </ion-accordion>
  </ion-accordion-group>
</red-page-content>
